import { z } from 'zod';

import { OptionSchema } from 'components/forms/validationSchemas';

export const newslettersValidation = z.object({
  newsletters: z.array(z.number()).default([]),
});

export const topicsValidation = z.object({
  organizationAlerts: z.array(OptionSchema).default([]),
  vendorAlerts: z.array(OptionSchema).default([]),
  venueAlerts: z.array(OptionSchema).default([]),
});

export const channelsValidation = z.object({
  email: z.boolean().default(false),
  push: z.boolean().default(false),
  sms: z.boolean().default(false),
});
